// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"892":"7ead4607","1608":"7ead4607","5683":"c18b0de7","6999":"6d152c98","7028":"7ead4607","8688":"27dd0431"}[chunkId] + ".chunk.css";
};